import { memo as Memo, useMemo } from 'react'

//* HOC
import withDataContext from 'context/consumerHOC/DataConsumer'

//* Components
import Page from 'components/common/Page'
import CocktailsSection from 'components/common/CocktailsSection'
import Hero from 'components/pages/cocktail/individual/HeroSection'
import MakeVideo from 'components/pages/cocktail/individual/MakeVideoSection'

const SingleCocktail = Memo(({ singleCocktail, pageParams, selectedLang, config }) => {
    //! Page data
    const pageData = useMemo(() => singleCocktail?.[pageParams.selectedSlug]?.[selectedLang], [singleCocktail, pageParams, selectedLang])

    return (
        <Page
            meta={pageData?.cocktail?.meta}
            className={'single-cocktail'}
        >
            {pageData && (
                <>
                    <Hero
                        url={config.cocktails.path}
                        name={pageData.cocktail.name}
                        text={pageData.cocktail?.text}
                        time={pageData.cocktail?.time}
                        tools={pageData.cocktail?.tools}
                        glass={pageData.cocktail?.glass}
                        garnish={pageData.cocktail.garnish}
                        methods={pageData.cocktail.methods}
                        occasion={pageData.cocktail?.occasion}
                        image={pageData.cocktail.featured_image}
                        difficulty={pageData.cocktail?.difficulty}
                        ingredients={pageData.cocktail.ingredients}
                    />

                    <MakeVideo
                        title={`howToMake`}
                        src={pageData.cocktail.make_video.src}
                    />

                    {pageData.relatedCocktails && pageData.relatedCocktails.length > 0 && (
                        <CocktailsSection
                            title={`cocktailsWithOurProduct`}
                            cocktails={pageData.relatedCocktails}
                            button={{ url: config.cocktails.path, text: 'seeAllCocktails' }}
                        />
                    )}
                </>
            )}
        </Page>
    )
})
export default withDataContext(SingleCocktail, ['singleCocktail'])
